import { api } from "@api/api";
import { Prescriber } from "@modules/prescribers/types";
import { PrescriberFormValues } from "@modules/prescribers/validations";

export async function createPrescriberService(data: PrescriberFormValues): Promise<Prescriber> {
  const { data: prescriber } = await api.post<Prescriber>("v1/prescriber_admin/", data);

  return prescriber;
}
